// NotFoundPage.js
import React from 'react';

const NotFoundPage = () => {
  return (
    <div>
      <h2>Page Not Found</h2>
      <p>The page you're looking for doesn't exist.</p>
    </div>
  );
};

export default NotFoundPage;